export default __webpack_public_path__ + "static/media/PCOREA2.beca57bb.png";